import { CheckCircle, DeleteCircle, InfoEmpty, WarningCircle } from '../../icons'

export const IconAliases = {
  Info: InfoEmpty,
  Success: CheckCircle,
  Warning: WarningCircle,
  Error: DeleteCircle,
}
